module.exports = __webpack_public_path__ + "static/media/YB5F14_0.b69143e3.jpg";